import Tooltip from '../../../ui/Tooltip';
import IconInfo from '../../icon/IconInfo';
import React from 'react';

export default function RatingTooltip() {
  return (
    <Tooltip
      content={(
        <div className="w-64">This question has a different wording (<em>General impression of the
                                                                         trainer/facilitator</em>)
                              for events of Collaboration Superpowers, European Scrum, Lean Change Management,
                              Management 3.0, ShiftUp, Personal Agility Institute and Scrum Ambassadors
                              brands.
        </div>)}
      label="ratingTip" className="pl-0.5">
      <IconInfo className="text-gray-dark "/>
    </Tooltip>
  );
}
